const BADGE_OVERFLOW_GAP_PX = 8;

/**
 * Given measured badge widths, returns how many items fit on one row before "+N more".
 * Uses a conservative "+99 more" probe width so the overflow chip never wraps/clips.
 */
export function computeBadgeOverflowFit(
  availableWidth: number,
  itemWidths: readonly number[],
  moreBadgeWidth: number,
  gap = BADGE_OVERFLOW_GAP_PX,
): number {
  const count = itemWidths.length;
  if (count === 0 || availableWidth <= 0) return 0;
  if (count === 1) return 1;

  let allItemsWidth = 0;
  for (let i = 0; i < count; i++) {
    allItemsWidth += itemWidths[i] + (i > 0 ? gap : 0);
  }
  if (allItemsWidth <= availableWidth) return count;

  for (let visible = count - 1; visible >= 1; visible--) {
    let rowWidth = 0;
    for (let i = 0; i < visible; i++) {
      rowWidth += itemWidths[i] + (i > 0 ? gap : 0);
    }
    rowWidth += gap + moreBadgeWidth;
    if (rowWidth <= availableWidth) return visible;
  }

  return 1;
}

export {BADGE_OVERFLOW_GAP_PX};
